import { ref } from "vue";
import useCommonChart from "@/mixins/apexChart/commonChart";
import { t } from "@/controllerLK/AvalLocalization";

export default function useColumnChart({noDataText, stacked = false}, categories, series, hideLegends = false) {

    const chartOptions =  ref({
        chart: {
            type: "bar",
            stacked: true,
            offsetY: 5,
            toolbar: {
                show: false
            }
        },
        fill: {
            opacity: 1,
        },
        legend: {
            show: !hideLegends, // Скрыть легенды
            showForSingleSeries: true,
            fontSize: 14,
        },
        grid: {
            show: false,
            padding: {
                bottom: hideLegends ? 0 : 25,
            },
        },
        plotOptions: {
            chart: {
                type: "bar",
                height: 350
            },
            bar: {
                borderRadius: 8,
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "last",
                horizontal: false,
                barHeight: stacked ? "70%" : "45%",
                dataLabels: {
                  total: {
                    enabled: true,
                    offsetY: -10,
                    style: {
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#000"
                    }
                  }
                }
                // dataLabels: {
                //     total: { enabled: true },
                // },
            },
        },
        title: {
            text: " ",
            align: "left",
            offsetX: 0,
            offsetY: 0,
            floating: false,
            margin: 20,
            style: {
                fontFamily: "Lato",
                fontSize: "14px",
                fontWeight: 200,
                color: "#000"
            },
        },
        dataLabels: {
            enabled: false
        },
        states: {
            hover: {
                filter: { type: "none" },
            },
        },
        xaxis: {
            categories: categories,
            labels: {
                formatter: function (val) {
                    if (
                        Array.isArray(series?.value?.[0]?.data) &&
                        series.value[0].data.length < 1
                    ) {
                        return "";
                    }
                    if (stacked) return val;
                    return val;
                },
                style: {
                    colors: "#878787"
                },
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    if (
                        Array.isArray(series?.value?.[0]?.data) &&
                        series.value[0].data.length < 1
                    ) {
                        return "";
                    }
                    return val;
                },
                style: {
                    colors: "#878787"
                },
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    if (stacked) return Math.round(val) + "%";
                    return val;
                }
            }
        },
        noData: {
            text: noDataText ? noDataText : t("common_chart.no_data.text")
        }
    });

    useCommonChart(chartOptions, categories, series);

    return {
        chartOptions,
    };
}